import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ScrollReveal, FloatingImage } from '@/components/Animations';
import { ExternalLink } from 'lucide-react';
import LoginModal from '@/components/LoginModal';

const METS_IMG = 'https://static.wixstatic.com/media/d52a7700b0804bdc8f6715c0a0b5dc94.jpg/v1/fill/w_600,h_400,al_c,q_80/d52a7700b0804bdc8f6715c0a0b5dc94.jpg';
const LUNCH_IMG = 'https://static.wixstatic.com/media/bf3085_af7f992c543643bfbeb0373621d67df1~mv2.jpg/v1/fill/w_500,h_520,al_c,q_80/AEnB2UoQ0Q5N1TJp_f_ZXE5rM6wdAZpnxSJNpxv8.jpg';
const EVENT_IMG1 = 'https://static.wixstatic.com/media/bf3085_fffe3512ed0b495a91e6c58e0938a686~mv2.jpg/v1/fill/w_400,h_520,al_c,q_80/image_edited.jpg';
const EVENT_IMG2 = 'https://static.wixstatic.com/media/11062b_ed024479864e41dca7acc33c28a98754~mv2.jpg/v1/fill/w_500,h_350,al_c,q_80/11062b_ed024479864e41dca7acc33c28a98754~mv2.jpg';
const EVENT_IMG3 = 'https://static.wixstatic.com/media/bf3085_9344bd945fef4dd2a3a37f592056ea2b~mv2.jpg/v1/fill/w_500,h_380,al_c,q_80/bf3085_9344bd945fef4dd2a3a37f592056ea2b~mv2.jpg';
const COMPTOIR_IMG = 'https://static.wixstatic.com/media/bf3085_529b87fc15264669b1f1d2a2630d2287~mv2.jpg/v1/fill/w_400,h_400,al_c,q_80/bf3085_529b87fc15264669b1f1d2a2630d2287~mv2.jpg';

export default function Services() {
  const navigate = useNavigate();
  const [showLogin, setShowLogin] = useState(false);

  const isLoggedIn = () => {
    try { return !!JSON.parse(localStorage.getItem('cg-customer')); } catch { return false; }
  };
  const isAdmin = () => !!localStorage.getItem('admin_token');

  const handleCommande = () => {
    // Temporaire: redirige vers l'ancien site de commande
    window.open('https://conceptgourmet.order-online.ai/#/', '_blank');
  };

  return (
    <div data-testid="services-page">
      <section className="py-20 sm:py-28 px-4" data-testid="services-hero">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <p className="text-xs uppercase tracking-[0.3em] mb-4 font-semibold" style={{ fontFamily: 'Outfit, sans-serif', color: 'var(--color-primary)' }}>
              Ce que nous offrons
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              NOS SERVICES
            </h1>
          </ScrollReveal>
        </div>
      </section>

      {/* METS CUISINÉS */}
      <section className="pb-20 px-4" data-testid="service-mets">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" style={{ borderBottom: '1px solid var(--color-border)', paddingBottom: '3rem' }}>
          <ScrollReveal>
            <div className="space-y-4">
              <h2 className="text-3xl font-semibold" style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--color-primary)' }}>METS CUISINÉS</h2>
              <p className="text-base leading-relaxed">Plat fait maison et frais. Plusieurs menus vous sont proposés à chaque semaine. Variétés et saveurs sont au rendez-vous. Idéal si vous êtes seul ou pour la famille afin de vous aider dans vos plats cuisinés. Livraison disponible.</p>
              <p className="text-base leading-relaxed">Ce service est offert également aux garderies et aux CPE ainsi que dans les résidences de personnes âgées.</p>
              <p className="text-base leading-relaxed">Ce service est disponible en certificat cadeau. Simple à offrir et qui a un grand impact dans la préparation des repas. Tout le monde mérite de manger bien et profitez d'un congé de popote !</p>
              <button onClick={handleCommande} data-testid="service-link-mets"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105 hover:shadow-lg mt-2 cursor-pointer"
                style={{ backgroundColor: 'var(--color-primary)', color: '#fff' }}>
                Cliquez ici pour commander
              </button>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={0.15}>
            <FloatingImage src={METS_IMG} alt="Mets cuisinés" className="w-full max-w-md mx-auto rounded-2xl overflow-hidden shadow-xl" duration={6} />
          </ScrollReveal>
        </div>
      </section>

      {/* BOÎTES À LUNCH */}
      <section className="pb-20 px-4" data-testid="service-lunch">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" style={{ borderBottom: '1px solid var(--color-border)', paddingBottom: '3rem' }}>
          <ScrollReveal>
            <FloatingImage src={LUNCH_IMG} alt="Boîtes à lunch" className="w-full max-w-md mx-auto rounded-2xl overflow-hidden shadow-xl" duration={7} />
          </ScrollReveal>
          <ScrollReveal delay={0.15}>
            <div className="space-y-4">
              <h2 className="text-3xl font-semibold" style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--color-primary)' }}>BOÎTES À LUNCH</h2>
              <p className="text-base leading-relaxed">Ce service est offert sous forme de salade-repas ou en boîte à lunch incluant une variété de sandwichs, salades, accompagnements et desserts. Idéal pour vos réunions d'affaires ou pour partir en pique-nique en famille !</p>
              <p className="text-base leading-relaxed">Nous offrons également ce service dans les établissements scolaires.</p>
              <button onClick={handleCommande} data-testid="service-link-lunch"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105 hover:shadow-lg mt-2 cursor-pointer"
                style={{ backgroundColor: 'var(--color-primary)', color: '#fff' }}>
                Cliquez ici pour commander
              </button>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* TOUT POUR VOS ÉVÉNEMENTS */}
      <section className="pb-20 px-4" data-testid="service-events">
        <div className="max-w-6xl mx-auto" style={{ borderBottom: '1px solid var(--color-border)', paddingBottom: '3rem' }}>
          <ScrollReveal>
            <h2 className="text-3xl font-semibold mb-8" style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--color-primary)' }}>TOUT POUR VOS ÉVÉNEMENTS</h2>
          </ScrollReveal>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            <ScrollReveal delay={0.1}>
              <div className="space-y-4">
                <h3 className="text-xl font-semibold" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Bouchées apéritives</h3>
                <p className="text-base leading-relaxed">Pour vos 5 à 7 ou pour compléter votre repas, les bouchées sont idéales pour épater vos invités. Vendues à la douzaine ou en formule.</p>
                <h3 className="text-xl font-semibold mt-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Buffet froid</h3>
                <p className="text-base leading-relaxed">Plusieurs formules sont créées afin de vous guider dans votre sélection. Optez pour le tout inclus ou pour certains produits afin d'aider vos préparations. Concept Gourmet est là !</p>
                <p className="text-base leading-relaxed">Nous avons l'option de buffet froid pour les funérailles également à prix forfaitaire pour les groupes.</p>
              </div>
            </ScrollReveal>
            <ScrollReveal delay={0.15}>
              <div className="space-y-4">
                <h3 className="text-xl font-semibold" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Pâtisseries</h3>
                <p className="text-base leading-relaxed">Vous aimeriez faire préparer un dessert pour une occasion spéciale ? Concept Gourmet réalise des gâteaux et des pâtisseries personnalisés. Plusieurs variétés vous sont proposées tout au long de l'année dans nos mets cuisinés ainsi qu'au comptoir lunch.</p>
                <h3 className="text-xl font-semibold mt-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Déjeuner et collations</h3>
                <p className="text-base leading-relaxed">Sous forme de buffet ou de boîte à lunch, cette option est parfait pour compléter vos réunions d'affaires ou vos escapades.</p>
              </div>
            </ScrollReveal>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <ScrollReveal delay={0.2}><img src={EVENT_IMG1} alt="Pâtisseries" className="w-full h-64 object-cover rounded-2xl shadow-lg" /></ScrollReveal>
            <ScrollReveal delay={0.25}><img src={EVENT_IMG2} alt="Buffet" className="w-full h-64 object-cover rounded-2xl shadow-lg" /></ScrollReveal>
            <ScrollReveal delay={0.3}><img src={EVENT_IMG3} alt="Événements" className="w-full h-64 object-cover rounded-2xl shadow-lg" /></ScrollReveal>
          </div>
        </div>
      </section>

      {/* COMPTOIR LUNCH */}
      <section className="pb-20 px-4" data-testid="service-comptoir">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <ScrollReveal>
            <div className="space-y-4">
              <h2 className="text-3xl font-semibold" style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--color-primary)' }}>COMPTOIR LUNCH</h2>
              <p className="text-base leading-relaxed">Concept Gourmet a un comptoir lunch situé à St-Marc-des-Carrières qui est composé de sandwicheries, salades et gourmandises sucrées. Il y a aussi une variété de mets préparés qui nécessite aucune commande préalablement. Super pour des dîners ou des soupers vite fait bien fait !</p>
              <p className="text-xl font-semibold mt-4" style={{ color: 'var(--color-primary)' }}>Passez nous voir !</p>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={0.15}>
            <div className="w-full max-w-md mx-auto rounded-2xl overflow-hidden shadow-xl aspect-square relative" style={{ border: '1px solid var(--color-border)' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2700!2d-72.0489!3d46.6847!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cb8a1a1a1a1a1a1%3A0x0!2s1335+Boulevard+Bona-Dussault%2C+Saint-Marc-des-Carri%C3%A8res%2C+QC+G0A+4B0!5e0!3m2!1sfr!2sca!4v1700000000000!5m2!1sfr!2sca"
                width="100%" height="100%" style={{ border: 0 }} allowFullScreen="" loading="lazy"
                referrerPolicy="no-referrer-when-downgrade" title="Concept Gourmet - Localisation"
              />
              <a href="https://www.google.com/maps/dir/?api=1&destination=1335+Boulevard+Bona-Dussault,+Saint-Marc-des-Carri%C3%A8res,+QC+G0A+4B0"
                target="_blank" rel="noopener noreferrer"
                className="absolute bottom-0 left-0 right-0 flex items-center justify-center gap-2 py-2.5 text-sm font-semibold text-white transition-all hover:opacity-90"
                style={{ backgroundColor: 'rgba(26,35,24,0.88)', backdropFilter: 'blur(8px)' }}>
                Itineraire
              </a>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-16 sm:py-24 px-4 text-center" style={{ backgroundColor: 'var(--color-muted)' }}>
        <ScrollReveal>
          <p className="text-lg mb-2 font-medium">Certificat-Cadeau disponible!</p>
          <p className="text-lg mb-4">Pour obtenir les formules et la tarification des différents menus, contactez-nous !</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-6">
            <a href="tel:4182857251" className="text-xl font-semibold" style={{ color: 'var(--color-primary)' }}>418-285-7251</a>
            <a href="mailto:info@conceptgourmet.ca" className="text-xl font-semibold" style={{ color: 'var(--color-secondary)' }}>info@conceptgourmet.ca</a>
          </div>
        </ScrollReveal>
      </section>
      <LoginModal isOpen={showLogin} onClose={() => setShowLogin(false)} redirectTo="/commande" />
    </div>
  );
}
